import React, {} from 'react';
const styles = {"emphasis":"Emphasis-module__emphasis__b46Nk","previewText":"Emphasis-module__previewText__-zXSX"};
/** Strong text inside muted copy, such as the address in "We sent a 6-digit code to …" (frame D1). */
export function Emphasis({ children }) {
    return React.createElement("strong", { className: styles.emphasis }, children);
}
//# sourceMappingURL=Emphasis.js.map